/* Oruz: ajustes en vivo (JS). Se edita reemplazando este archivo en Contenido > Archivos. */
(function () {
  'use strict';

  /* ===== Aviso de envío gratis en el carrito =====
     Regla de la tienda (Configuración > Envío y entrega): los pedidos de menos de $300.000 pagan $13.000 de envío
     nacional; desde $300.000 el envío es gratis. Los lentes de Halloween tienen el envío incluido.
     Si cambia la regla en Shopify, cambiar UMBRAL aquí. */
  var RAIZ = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ===== «Comprar ahora» en gafas y en el selector de lentes =====
     Agrega lo elegido (con sus lentes, si los escogió) y lleva directo a la pantalla de pago, sin pasar por el carrito.
     Usa el mismo envío al carrito de la página (con sus revisiones y mensajes de error); si Shopify lo acepta, en vez de
     ir al carrito va al pago. Si algo falla, el cliente ve el mismo aviso de siempre y no se va de la página. */
  var pagoYa = false;
  if (window.fetch && !window.__ozPagoYa) {
    window.__ozPagoYa = true;
    var fetch0 = window.fetch;
    window.fetch = function (url) {
      var u = typeof url === 'string' ? url : (url && url.url) || '';
      if (!pagoYa || !/\/cart\/add(\.js)?(\?|$)/.test(u)) return fetch0.apply(this, arguments);
      pagoYa = false;
      return fetch0.apply(this, arguments).then(function (r) {
        if (!r.ok) return r;
        return r.clone().json().then(function (d) {
          if (d && d.status) return r;
          window.location.href = RAIZ + 'checkout';
          return new Promise(function () {}); /* la página se va al pago; no sigue hacia el carrito */
        }, function () { return r; });
      });
    };
  }
  function disparar(btn) { pagoYa = true; try { btn.click(); } finally { pagoYa = false; } }

  /* Página de cada gafa (pedido del dueño, 15 oct): «Comprar ahora» (amarillo), «Agregar al carrito» (negro) y abajo
     el botón de lentes, que pasa a decir «Agregar lentes con fórmula y de descanso» (en gafas de sol: «Agregar lentes con fórmula») porque es opcional. */
  function botonGafa(root) {
    var atc = root.querySelector('[data-oz-atc]');
    if (!atc || root.getAttribute('data-oz-ahora')) return;
    root.setAttribute('data-oz-ahora', '1');
    /* el botón amarillo queda siempre como «Agregar al carrito» y lleva al carrito (en alguna plantilla decía «Comprar Ahora») */
    if (/\/checkout\/?$/.test(root.getAttribute('data-redirect') || '')) {
      root.setAttribute('data-redirect', RAIZ + 'cart');
      var tx = atc.querySelector('.oz-u5__btntext');
      if (tx && tx.firstChild && tx.firstChild.nodeType === 3) tx.firstChild.nodeValue = 'Agregar al carrito ';
      atc.setAttribute('aria-label', 'Agregar al carrito');
    }
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'oz-ahora'; b.textContent = 'Comprar ahora';
    atc.parentNode.insertBefore(b, atc);
    var lentes = atc.parentNode.querySelector('.oz-lentes-btn');
    if (lentes && lentes.parentNode === atc.parentNode) {
      atc.parentNode.insertBefore(lentes, atc.nextSibling);
      var sol = false;
      try { sol = JSON.parse(document.getElementById('oz-lentes-datos').textContent).flujo === 'sol'; } catch (e) {}
      lentes.textContent = sol ? 'Agregar lentes con fórmula' : 'Agregar lentes con fórmula y de descanso';
      lentes.setAttribute('aria-label', lentes.textContent);
    }
    function listo() { b.classList.remove('is-carga'); b.textContent = 'Comprar ahora'; b.disabled = atc.disabled; }
    b.addEventListener('click', function () {
      if (atc.disabled || atc.getAttribute('data-state') === 'loading') return;
      b.classList.add('is-carga'); b.textContent = 'Procesando…';
      disparar(atc);
      setTimeout(function () { if (atc.getAttribute('data-state') !== 'loading') listo(); }, 80);
    });
    new MutationObserver(function () {
      if (b.classList.contains('is-carga')) { if (atc.getAttribute('data-state') !== 'loading') listo(); }
      else if (b.disabled !== atc.disabled) b.disabled = atc.disabled;
    }).observe(atc, { attributes: true, attributeFilter: ['disabled', 'data-state'] });
    b.disabled = atc.disabled;
  }

  /* Selector de lentes: en «Revisa tu pedido», «Comprar ahora» junto a «Añadir al carrito». */
  function botonSelector() {
    var pie = document.querySelector('#oz-lentes [data-oz-pie]'); if (!pie) return;
    var agregar = pie.querySelector('[data-a="agregar"]');
    var mio = pie.querySelector('.oz-ahora-l');
    if (!agregar) { if (mio) mio.remove(); return; }
    if (!mio) {
      mio = document.createElement('button');
      mio.type = 'button'; mio.className = 'oz-lentes__btn oz-ahora-l'; mio.textContent = 'Comprar ahora';
      mio.addEventListener('click', function (e) {
        e.stopPropagation();
        var a = document.querySelector('#oz-lentes [data-oz-pie] [data-a="agregar"]');
        if (!a || a.disabled || a.classList.contains('is-carga')) return;
        mio.classList.add('is-carga'); mio.textContent = 'Procesando…';
        disparar(a);
      });
      agregar.parentNode.insertBefore(mio, agregar.nextSibling);
    }
    var cargando = agregar.classList.contains('is-carga');
    if (!cargando && mio.classList.contains('is-carga')) { mio.classList.remove('is-carga'); mio.textContent = 'Comprar ahora'; }
    if (mio.disabled !== agregar.disabled) mio.disabled = agregar.disabled;
  }

  function gafas() {
    [].forEach.call(document.querySelectorAll('.oz-u5'), botonGafa);
    var vigia = null;
    function mira() {
      var r = document.getElementById('oz-lentes');
      if (!r || vigia) return;
      vigia = new MutationObserver(botonSelector);
      vigia.observe(r, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-pantalla', 'hidden', 'disabled', 'class'] });
      botonSelector();
    }
    mira();
    if (!vigia) { var o = new MutationObserver(function () { mira(); if (vigia) o.disconnect(); }); o.observe(document.body, { childList: true }); }
  }
  if (document.querySelector('.oz-u5')) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', gafas); else gafas();
  }

  var UMBRAL = 300000, HALLOWEEN = 10346169401590;
  if (!/^\/cart\/?$/.test(location.pathname)) return;

  var CAMION = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 6h11v10H2z"/><path d="M13 9h4.5L21 12.5V16h-8z"/><circle cx="6.5" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>';
  var CHULO = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var caja = null, reloj = null;

  function plata(n) { return '$' + String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }

  function crea() {
    var d = document.createElement('div');
    d.className = 'oz-eg'; d.setAttribute('role', 'status'); d.setAttribute('aria-live', 'polite'); d.hidden = true;
    d.innerHTML = '<p class="oz-eg__txt" data-txt></p>' +
      '<div class="oz-eg__barra" aria-hidden="true"><i data-fill></i><span class="oz-eg__cam" data-cam></span></div>' +
      '<div class="oz-eg__meta" aria-hidden="true"><span data-desde></span><span data-hasta></span></div>' +
      '<p class="oz-eg__sub" data-sub></p>';
    return d;
  }

  function monta() {
    if (caja && document.contains(caja)) return true;
    var ci = document.querySelector('cart-items'); if (!ci) return false;
    var tit = ci.querySelector('.title-wrapper-with-link');
    caja = caja || crea();
    if (tit && tit.parentNode) tit.parentNode.insertBefore(caja, tit.nextSibling);
    else ci.insertBefore(caja, ci.firstChild);
    return true;
  }

  function pinta(c) {
    var env = (c && c.items || []).filter(function (i) { return i.requires_shipping; });
    if (!env.length) { if (caja) caja.hidden = true; return; }
    if (!monta()) return;
    var total = env.reduce(function (s, i) { return s + i.final_line_price; }, 0) / 100;
    var soloHw = env.every(function (i) { return i.product_id === HALLOWEEN; });
    var falta = UMBRAL - total, listo = soloHw || falta <= 0;
    var pct = listo ? 100 : Math.max(8, Math.min(94, total / UMBRAL * 100));
    var q = function (s) { return caja.querySelector(s); };
    caja.classList.toggle('is-listo', listo);
    if (soloHw) {
      q('[data-txt]').innerHTML = '<b>Envío incluido</b> en tus lentes de Halloween';
      q('[data-sub]').textContent = 'A toda Colombia, sin costo adicional.';
    } else if (listo) {
      q('[data-txt]').innerHTML = '<b>¡Tienes envío gratis!</b>';
      q('[data-sub]').textContent = 'Tu pedido ya supera los ' + plata(UMBRAL) + '.';
    } else {
      q('[data-txt]').innerHTML = 'Te faltan <b class="oz-eg__monto">' + plata(falta) + '</b> para el <b>envío gratis</b>';
      q('[data-sub]').textContent = '¡No te quedes sin la oportunidad!';
    }
    q('[data-desde]').textContent = soloHw ? '' : plata(total);
    q('[data-hasta]').textContent = soloHw ? '' : 'Envío gratis · ' + plata(UMBRAL);
    q('[data-cam]').innerHTML = listo ? CHULO : CAMION;
    var mostrar = caja.hidden; caja.hidden = false;
    var pon = function () { q('[data-fill]').style.width = pct + '%'; q('[data-cam]').style.left = pct + '%'; };
    if (mostrar && window.requestAnimationFrame) requestAnimationFrame(function () { requestAnimationFrame(pon); }); else pon();
  }

  function lee() {
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(pinta).catch(function () {});
  }
  function pronto() { clearTimeout(reloj); reloj = setTimeout(lee, 250); }

  function arranca() {
    lee();
    try { if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, pronto); } catch (e) {}
    var lista = document.getElementById('main-cart-items');
    if (lista && window.MutationObserver) new MutationObserver(pronto).observe(lista, { childList: true, subtree: true });
    window.addEventListener('pageshow', function (e) { if (e.persisted) lee(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arranca); else arranca();
})();

/* ===== Página de producto: textos que el dueño cambió después de publicar =====
   En gafas de sol, la opción «Como vienen» se llama «Gafas de sol».
   No se muestra el peso («Solo 24 g, liviana»): si quedan más de 4 ventajas se quita; si no, dice «Liviana para todo el día». */
(function () {
  'use strict';
  function textos() {
    var b = document.querySelectorAll('.ozp__op[data-modo="sola"] b');
    for (var i = 0; i < b.length; i++) if (b[i].textContent.trim() === 'Como vienen') b[i].textContent = 'Gafas de sol';
    var ul = document.querySelectorAll('.ozp__ventajas');
    for (var j = 0; j < ul.length; j++) {
      var li = ul[j].children;
      for (var k = li.length - 1; k >= 0; k--) {
        if (!/^Solo [\d.,]+\s*g, liviana$/.test(li[k].textContent.trim())) continue;
        if (li.length > 4) ul[j].removeChild(li[k]); else li[k].lastChild.textContent = 'Liviana para todo el día';
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', textos); else textos();
})();
